export default "__VITE_ASSET__BMH4Rvkx__"